<template>
  <div class='cusLayer full' id='origin'>
    <!-- Header -->
    <div class='cusHd'>
      <div class='row borer_Bottom'>
        <div class='col w100p'><h1 class='tit'>원산지</h1></div>
        <div class='col col3'>
          <button type='button' class='btnCloseModal' @click='removePopUp()'>
            {{$t('Shop.close')}}
          </button>
        </div>
      </div>
    </div>
    <!-- 매장 정보 -->
    <div class='cusCnt'>
      <div class="originDesc">
        {{this.stores[this.currentStoreCode].originDesc}}
      </div>
    </div>
  </div>
</template>
<script lang="js">
import Vue from 'vue'
export default Vue.extend({
  computed: {
    stores () { return this.$store.getters.stores },
    currentStoreCode () { return this.$store.getters.currentStoreCode }
  },
  beforeDestroy () {
    this.removePopUp()
  }
})
</script>
